<template>
  <modal
    disable-close-backdrop
    title="Watchlist Alerts"
    :open="open"
    @close="closeModal"
  >
    <div class="description">
      <div>{{ card.label }}</div>
      <div>Value: {{ $filters.currency(card.currentValue, { full: true }) }}</div>
    </div>

    <br />

    <form @submit.stop.prevent="submit">
      <currency-input
        id="alertBelowPrice"
        v-model="alertBelowPrice"
        label="Alert me when it drops below this price"
      >
        <icon-button icon="close" @click="clearBelow" />
      </currency-input>

      <currency-input
        id="alertAbovePrice"
        v-model="alertAbovePrice"
        label="Alert me when it goes above this price"
      >
        <icon-button icon="close" @click="clearAbove" />
      </currency-input>

      <div class="button-row">
        <btn
          type="submit"
          loading-text="Submitting"
          :loading="submitting"
        >
          Submit
        </btn>

        <btn kind="secondary" @click="closeModal">
          Cancel
        </btn>
      </div>
    </form>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import * as Sentry from '@sentry/vue';

import { authService } from '@/services';

export default {
  data() {
    return {
      open: false,
      alertBelowPrice: null,
      alertAbovePrice: null,
      card: {},
      submitting: false,
    };
  },

  mounted() {
    this.$bus.$on('watchlist-alert-setup', this.handle);
  },

  beforeDestroy() {
    this.$bus.$off('watchlist-alert-setup', this.handle);
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },

  methods: {
    handle(card) {
      this.reset();

      this.card = card;

      if (card.alertBelowPrice) {
        this.alertBelowPrice = card.alertBelowPrice;
      }

      if (card.alertAbovePrice) {
        this.alertAbovePrice = card.alertAbovePrice;
      }

      this.open = true;
    },

    async submit() {
      this.submitting = true;

      try {
        const update = {
          alertBelowPrice: this.alertBelowPrice || null,
          alertAbovePrice: this.alertAbovePrice || null,
        };

        await authService.updateWatchlistCard(this.user.uid, this.card.cardId, update);

        this.$toasted.success('Setup alerts for this card!');

        this.$bus.$emit('watchlist-changed', { edit: { cardId: this.card.cardId, ...update } });
        this.$bus.$emit('card-profile-changed');
        this.closeModal();
      } catch (e) {
        this.$toasted.error('Error setting up your alerts');
        Sentry.captureException(e);
      }

      this.submitting = false;
    },

    clearBelow() {
      this.alertBelowPrice = null;
    },

    clearAbove() {
      this.alertAbovePrice = null;
    },

    closeModal() {
      if (this.$refs?.form?.reset) {
        this.$refs.form.reset();
      }

      this.open = false;
    },

    reset() {
      this.alertBelowPrice = null;
      this.alertAbovePrice = null;
      this.card = {};
    },
  },
};
</script>
